// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function authContextConverter(data) {
  var user = Belt_Option.map(data.user, (function (user) {
          return {
                  authToken: user.auth_token,
                  mobile: user.mobile,
                  name: user.name,
                  requirementType: user.requirement_type,
                  email: user.email,
                  whatsappConsent: user.whatsapp_consent
                };
        }));
  var agreedDocs = Belt_Option.map(data.agreed_docs, (function (agreedDocs) {
          return {
                  agreedDocs: agreedDocs.agreed_docs.map(function (doc) {
                        return {
                                docType: doc.doc_type,
                                docUrl: doc.doc_url,
                                createdAt: doc.created_at,
                                updatedAt: doc.updated_at
                              };
                      }),
                  tncUrl: agreedDocs.tnc_url,
                  privacyPolicyUrl: agreedDocs.privacy_policy_url
                };
        }));
  var setUser = function (user) {
    Curry._1(data.set_user, Belt_Option.map(user, (function (user) {
                return {
                        auth_token: user.authToken,
                        mobile: user.mobile,
                        name: user.name,
                        requirement_type: user.requirementType,
                        email: user.email,
                        whatsapp_consent: user.whatsappConsent
                      };
              })));
  };
  return {
          user: user,
          setUser: setUser,
          agreedDocs: agreedDocs
        };
}

export {
  authContextConverter ,
}
/* No side effect */
